import { render } from "./WguAppTemplate.vue?vue&type=template&id=d2a23dac"
import script from "./WguAppTemplate.vue?vue&type=script&lang=js"
export * from "./WguAppTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__